// Pages/grantaide-database-site/SearchRow/index.js
import React, { useContext, useEffect, useState } from "react";
import { grantFilterContext } from "../Filter/GrantFilterProvider";
import styles from "./styles.module.css";

/** Search input only .
 *  searches the grants the page already downloaded */
export function SearchOnly() {
  const { searchText, setSearchText } = useContext(grantFilterContext);
  const [typed, setTyped] = useState(searchText);

  // Remember the user ID when searching
  useEffect(() => {
    setTyped(searchText == null ? "" : String(searchText));
  }, [searchText]);

  const submit = (e) => {
    e.preventDefault();
    setSearchText(typed.trim());
  };

  return (
    <div className={styles.searchOnly}>
      <div className={styles.searchMax}>
        <form onSubmit={submit} className={styles.searchForm}>
          <input
            type="search"
            placeholder="Search for Grants"
            aria-label="Search for Grants"
            className={styles.searchInput}
            value={typed}
            onChange={(e) => {
              setTyped(e.target.value);
              if (e.target.value === "") setSearchText("");
            }}
          />
        </form>
      </div>
    </div>
  );
}

/** Update banner only (to be placed above column 3) */
export function UpdateOnly() {
  return (
    <div className={styles.updateOnly}>
      <b className={styles.updateText}>Update:</b>{" "}
      The Hide/Hidden feature are disabled and will be implemented soon.
    </div>
  );
}

/** Backward-compatible default: renders BOTH stacked horizontally */
export default function SearchRow() {
  return (
    <div className={styles.wrapper}>
      <UpdateOnly />
      <SearchOnly />
    </div>
  );
}
